/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GetAccountsUsersCountsByStateRequest} from '../models/GetAccountsUsersCountsByStateRequest';

export interface GetAccountsUsersCountByState$Request {
    getAccountsUsersCountsByStateRequest: GetAccountsUsersCountsByStateRequest;
}

export interface GetAccountsUsersCountByState$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountsUsersCountByStateRequest = createAction<PayloadData<void, GetAccountsUsersCountByState$Request>>('ACCOUNTS_USERS_COUNTS__GET_ACCOUNTS_USERS_COUNT_BY_STATE__REQUEST');
export const getAccountsUsersCountByStateSuccess = createAction<PayloadData<{ [key: string]: number; }, GetAccountsUsersCountByState$Request>>('ACCOUNTS_USERS_COUNTS__GET_ACCOUNTS_USERS_COUNT_BY_STATE__SUCCESS');
export const getAccountsUsersCountByStateFailure = createAction<PayloadData<Error, GetAccountsUsersCountByState$Request, true>>('ACCOUNTS_USERS_COUNTS__GET_ACCOUNTS_USERS_COUNT_BY_STATE__FAILURE');

export const getAccountsUsersCountByStateActions = [
    getAccountsUsersCountByStateRequest,
    getAccountsUsersCountByStateSuccess,
    getAccountsUsersCountByStateFailure
] as const;

/**
 * @param {GetAccountsUsersCountsByStateRequest} meta.getAccountsUsersCountsByStateRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountsUsersCountByState = (meta: GetAccountsUsersCountByState$Request, config?: GetAccountsUsersCountByState$Config) => {
    return {
        CALL_API: {
            types: getAccountsUsersCountByStateActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/search/users-count-by-state`,
            TRANSPORT_REQUEST_BODY: meta.getAccountsUsersCountsByStateRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

